import{number as r}from"../../../value/types/numbers/index.mjs.js";const o={...r,transform:Math.round};export{o as int};
